const PKCE_STORAGE_KEY = 'oidc_pkce_data';
const PKCE_TTL_MS = 10 * 60 * 1000; // 10 минут

function base64urlEncode(buffer) {
  return btoa(String.fromCharCode(...new Uint8Array(buffer)))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
}

export function generateCodeVerifier() {
  const array = new Uint8Array(48);
  crypto.getRandomValues(array);
  return base64urlEncode(array);
}

export async function generateCodeChallenge(verifier) {
  const encoder = new TextEncoder();
  const data = encoder.encode(verifier);
  const digest = await crypto.subtle.digest('SHA-256', data);
  return base64urlEncode(digest);
}

export function generateRandomString() {
  const array = new Uint8Array(16);
  crypto.getRandomValues(array);
  return Array.from(array, (b) => b.toString(16).padStart(2, '0')).join('');
}

export function buildAuthorizationUrl({
  authorizationEndpoint,
  clientId,
  redirectUri,
  scope,
  codeChallenge,
  state,
  nonce,
}) {
  const params = new URLSearchParams({
    client_id: clientId,
    redirect_uri: redirectUri,
    response_type: 'code',
    scope: scope,
    code_challenge: codeChallenge,
    code_challenge_method: 'S256',
    state: state,
    nonce: nonce,
  });
  return `${authorizationEndpoint}?${params.toString()}`;
}

export function savePkceData({ codeVerifier, state }) {
  const data = {
    codeVerifier,
    state,
    timestamp: Date.now(),
  };
  sessionStorage.setItem(PKCE_STORAGE_KEY, JSON.stringify(data));
}

export function loadPkceData(state) {
  const raw = sessionStorage.getItem(PKCE_STORAGE_KEY);
  if (!raw) return null;

  try {
    const data = JSON.parse(raw);

    // TTL проверка
    if (Date.now() - data.timestamp > PKCE_TTL_MS) {
      clearPkceData();
      return null;
    }

    // Валидация state
    if (data.state !== state) {
      clearPkceData();
      return null;
    }

    return data;
  } catch {
    clearPkceData();
    return null;
  }
}

export function clearPkceData() {
  sessionStorage.removeItem(PKCE_STORAGE_KEY);
}

export function redirectToBlitzLogout({ logoutUrl, postLogoutRedirectUri, clientId }) {
  const params = new URLSearchParams({
    post_logout_redirect_uri: postLogoutRedirectUri,
    client_id: clientId,
  });
  window.location.href = `${logoutUrl}?${params.toString()}`;
}
